import { render } from "./InfoIcon.vue?vue&type=template&id=4f56f332&scoped=true"
const script = {}

import "./InfoIcon.vue?vue&type=style&index=0&id=4f56f332&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f56f332"]])

export default __exports__